import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { marketplacesSettingsActions } from '@/Pages/Settings/modules/MarketplacesSettings/services/reducer';
import { useDispatch } from 'react-redux';

export function useMarketplaceSettings() {
  const dispatch = useDispatch();

  const {
    tours: {
      MarketplaceSettings: { Default, Account },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Default.Title,
      steps: [
        {
          content: Default.Step1.Text,
          placement: 'auto',
          target: '#mpTitle',
          title: Default.Step1.Title,
          disableBeacon: true,
          link: Default.Step1.DetailsLink,
        },
        {
          content: Default.Step2.Text,
          placement: 'auto',
          target: '#mpTable',
          title: Default.Step2.Title,
          disableBeacon: true,
          link: Default.Step2.DetailsLink,
        },
        {
          content: Default.Step3.Text,
          placement: 'auto',
          target: '#crudExtended',
          title: Default.Step3.Title,
          disableBeacon: true,
          link: Default.Step3.DetailsLink,
        },
        {
          content: Default.Step4.Text,
          placement: 'auto',
          target: '.dx-toolbar-after',
          title: Default.Step4.Title,
          disableBeacon: true,
          link: Default.Step4.DetailsLink,
          spotlightPadding: 0,
          styles: {
            spotlight: {
              maxWidth: '500px',
            },
          },
        },
        {
          content: Default.Step5.Text,
          placement: 'auto',
          target: '#tableImportButton',
          title: Default.Step5.Title,
          disableBeacon: true,
          link: Default.Step5.DetailsLink,
          styles: {
            spotlight: {
              minWidth: '65px',
            },
          },
        },
        {
          content: Default.Step6.Text,
          placement: 'auto',
          target: '#mpForm',
          title: Default.Step6.Title,
          disableBeacon: true,
          link: Default.Step6.DetailsLink,
        },
      ],
    }),
    [Default],
  );

  const accountTour = useMemo<TourType>(
    () => ({
      id: 'accountTour',
      title: Account.Title,
      before: () => {
        dispatch(marketplacesSettingsActions.setMarketplaceModal({ visible: true }));
      },
      steps: [
        {
          content: Account.Step1.Text,
          placement: 'auto',
          target: '#mpModalTitle',
          title: Account.Step1.Title,
          disableBeacon: true,
          link: Account.Step1.DetailsLink,
        },
        {
          content: Account.Step2.Text,
          placement: 'auto',
          target: '#mpModalFields',
          title: Account.Step2.Title,
          disableBeacon: true,
          link: Account.Step2.DetailsLink,
        },
        {
          content: Account.Step3.Text,
          placement: 'auto',
          target: '#merchantModalFulfillment',
          title: Account.Step3.Title,
          disableBeacon: true,
          link: Account.Step3.DetailsLink,
        },
        {
          content: Account.Step4.Text,
          placement: 'auto',
          target: '#mpModalFulfillment',
          title: Account.Step4.Title,
          disableBeacon: true,
          link: Account.Step4.DetailsLink,
        },
        {
          content: Account.Step5.Text,
          placement: 'auto',
          target: '#syncModalField',
          title: Account.Step5.Title,
          disableBeacon: true,
          link: Account.Step5.DetailsLink,
        },
        {
          content: Account.Step6.Text,
          placement: 'auto',
          target: '#settingModalFlags',
          title: Account.Step6.Title,
          disableBeacon: true,
          link: Account.Step6.DetailsLink,
        },
        {
          content: Account.Step7.Text,
          placement: 'auto',
          target: '#invoiceModalFlags',
          title: Account.Step7.Title,
          disableBeacon: true,
          link: Account.Step7.DetailsLink,
        },
      ],
    }),
    [Account],
  );

  return [pageTour, accountTour];
}
